import { dataWhirlpool } from 'dls-icons-data'
import { createIcon } from '../common'

const IconWhirlpool = /*#__PURE__*/createIcon(dataWhirlpool)
export default IconWhirlpool
